export const useCalculatorSettings = () => {
  const INPUT_DEBOUNCE_TIME_IN_MILLISECONDS: number = 1200 as const;

  return {
    INPUT_DEBOUNCE_TIME_IN_MILLISECONDS,
  };
};
